export enum RequestTypes {
    Http = 0,
    InternalApi = 1,
    KartinaApiProxy = 2,
    ContentApi = 3,
    ODataApi = 4
}



// WEBPACK FOOTER //
// ./src/app/models/enums/request-types.enum.ts